import React, {useState,useEffect} from 'react'
import {
    useParams,
    Navigate,
    Link
} from 'react-router-dom';
import axios from "axios"
import Loader from '../../../components/Loader';
import axiosInstance from '../../../utils/api';

type Props = {}
interface SensorInterface {
    id?: number;
    serial: string;
    date_purchase?: string;
    name?: number;
    node?:string;
}

const SensorAddEdit = (props: Props) => {
    const {type, id} = useParams()
    const [loading, setLoading] = useState(false)
    const [inputs, setInputs] = useState([
        {
            serial: "",
            date_purchase: "",
            name: 0
        }
    ])
    const [input, setInput] = useState<SensorInterface>(
        {
            serial: "",
            date_purchase: "",
            name: 0
        }
    )
    const [sensorNameList, setSensorNameList] = useState<Array<SensorInterface>>([])

    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`https://api.cl-ds.com/internal/operations/v1/page/sensor/`).then(res => {
            setLoading(false)
            console.log(11, res.data.sensor)
            setSensorNameList(res.data.sensor)
        }).catch( err => {
            setLoading(false)
            console.log("[ERR]", err)
        })
        if (type=="edit" && id) {
            getData(id)
        }
    }, [])


    if (type!="add"&&type!="edit") {
        console.log(1, type)
        return <Navigate to="/" replace={true} />
    } else if (type=="add"&& id) {
        console.log(2, type)
        return <Navigate to="/" replace={true} />
    } else if (type=="edit"&& !id) {
        console.log(3, type)
        return <Navigate to="/" replace={true} />
    }

    
    function getData(id:string):void {
        setLoading(true)
        axiosInstance.get(`https://api.cl-ds.com/internal/operations/v1/sensor/${id}`).then(res => {
            setLoading(false)
            res.data.date_purchase = res.data.datetime.split("T")[0]
            console.log(12, res.data)
            setInput(res.data)
        }).catch(err => {
            setLoading(false)
            console.log(234, err)
            return <Navigate to="/" replace={true} />
        })
    }
    

    function handleSubmit() {
        if (type=="add") {
            console.log("add", inputs)

            for (let i in inputs) {
                if (inputs[i].name == 0) {
                    return alert("Name is required")
                }
                if (inputs[i].serial.length < 1) {
                    return alert("Serial is required")
                }
                if (inputs[i].date_purchase.length < 1) {
                    return alert("Date Purchase is required")
                } 
            }

            setLoading(true)
            axiosInstance.post("https://api.cl-ds.com/internal/operations/v1/sensor/", inputs).then((res:any) =>{
                setLoading(false)
                alert(res.data.message)
            }).catch( err => {
                setLoading(false)
                console.log(222, err)
            })
        } else {
            console.log("edit", input)

            if (input.name == 0) {
                return alert("Name is required")
            }
            if (input.serial.length < 1) {
                return alert("Serial is required")
            }
            if (!input.date_purchase || input.date_purchase.length < 1) {
                return alert("Date Purchase is required")
            }

            setLoading(true)
            axiosInstance.put(`https://api.cl-ds.com/internal/operations/v1/sensor/${id}/`, input).then((res:any) =>{
                setLoading(false)
                alert(res.data.message)
            }).catch( err => {
                setLoading(false)
                console.log(222, err)
            })
        }
    }

    function handleChange(e:React.ChangeEvent<HTMLInputElement>,field: string, index?:number ) {
        console.log("handleChange",  e.target.value)
        if (index!=null) {
            let newArr = [...inputs]
            newArr[index] = {
                ...newArr[index],
                [field]: e.target.value
            }
    
            setInputs(newArr)
        } else {
            setInput(prev => ({
                ...prev,
                [field]: e.target.value
            }))
        }
    }

    function addInput() {
        setInputs(prev => [...prev , {
            serial: "",
            date_purchase: "",
            name: 0
        }])
    }

    
    function removeInput(index:number) {
        setInputs(prev => [...prev , {
            serial: "",
            date_purchase: "",
            name: 0
        }])
        let newArr = inputs.filter( (input, i) => i != index)

        setInputs(newArr)
    }

    function handleChangeSelect(e:React.ChangeEvent<HTMLSelectElement>, index?:number) {
        console.log("handleChangeSelect", inputs, index)
        if (index!=null) {
            let newArr = [...inputs]
            newArr[index] = {
                ...newArr[index],
                "name": parseInt(e.target.value)
            }
    
            setInputs(newArr)
        } else {
            setInput(prev => ({
                ...prev,
                "name": parseInt(e.target.value)
            }))
        }
    }

    return (
        <div className="col-12">
        {loading && ( <Loader/> )}

            <div className="card">
                <div className="card-body">
                    <div style={{float: "right", margin: "1rem", marginLeft: 0}}>
                        <Link  to={`/sensor`} className="nav-link collapsed">
                            <button type="button" className="btn btn-outline-secondary">Back</button>
                        </Link>
                    </div>
                    <h5 className="card-title">{type=="add" ? "Create" : "Edit"} Sensor</h5>

                    {type == "add" && 
                        inputs.map( (input, index) => {
                            return (
                                <div style={{border:"1px dashed gray", padding: "1rem", borderRadius: 10, marginBottom:"1rem"}} key={index}>
                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Serial #{index}</label>
                                        <div className="col-sm-8">
                                            <input type="text" className="form-control" id="inputText" value={input.serial} onChange={(e)=>handleChange(e, "serial", index)}/>
                                        </div>
                                    </div>
                                    
                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Date Purchase</label>
                                        <div className="col-sm-8">
                                            <div className="col-sm-10 w-100">
                                                <input type="date" value={input.date_purchase} className="form-control" onChange={(e)=>handleChange(e, "date_purchase", index)}/>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Name</label>
                                        <div className="col-sm-8">
                                            <select className="form-select" aria-label="select" value={input.name || "0"} onChange={(e)=>handleChangeSelect(e, index)}>
                                                <option value={0} key={0}>-- Please Select --</option>
                                                {sensorNameList.map((sensor:any) => {
                                                    return (
                                                        <option value={sensor.id} key={sensor.id}>{sensor.name} ({sensor.supplier})</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                        <div className="col-sm-1" onClick={()=>{addInput()}}>
                                            <button type="button" className="btn btn-outline-info"><i className="bi bi-plus"></i></button>
                                        </div>
                                        {index!=0 && (
                                        <div className="col-sm-1" onClick={()=>{removeInput(index)}}>
                                            <button type="button" className="btn btn-outline-danger"><i className="bi bi-dash"></i></button>
                                        </div>
                                        )}
                                    </div>
                                </div>
                            )
                        })
                    }

                    {type == "edit" && 
                        <>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Serial</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="inputText" value={input.serial} onChange={(e)=>handleChange(e, "serial")} />
                            </div>
                        </div>
                        {/* <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Node</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="inputText" value={input.node} disabled/>
                            </div>
                        </div> */}
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Date Purchase</label>
                            <div className="col-sm-10">
                                <div className="col-sm-10 w-100">
                                    <input type="date" value={input.date_purchase} className="form-control" onChange={(e)=>handleChange(e, "date_purchase")}/>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Name</label>
                            <div className="col-sm-10">
                                <select className="form-select" aria-label="select" value={input.name || "0"} onChange={(e)=>handleChangeSelect(e)}>
                                    <option value={0} key={0}>-- Please Select --</option>
                                    {sensorNameList.map((sensor:any) => {
                                        return (
                                            <option value={sensor.id} key={sensor.id}>{sensor.name} ({sensor.supplier})</option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                        </>
                    }
                    
                    
                    <div className="text-start">
                        <button type="button" className="btn btn-outline-info" onClick={()=>handleSubmit()}>Submit</button>
                    </div>          

                </div>
            </div>

        </div>
    )
}

export default SensorAddEdit